import { createSlice } from "@reduxjs/toolkit";
import { getPokeInfo } from "./actions";

const initialState = () => ({
    pokemon: {
        items: false,
        loading: false,
        error: false,
    }
});

export const pokeSlice = createSlice({
    name: "pokeslice",
    initialState: initialState().pokemon,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getPokeInfo.pending, (source) => {
            source.loading = true;
        });
        builder.addCase(getPokeInfo.fulfilled, (source, action) => {
            source.items = action.payload;
            source.loading = false;
        });
        builder.addCase(getPokeInfo.rejected, (source) => {
            source.loading = false;
        });
    },
});

export const selectItems = (state) => state.pokemon.items;
export const selectLoading = (state) => state.pokemon.loading;
export const selectError = (state) => state.pokemon.error;

export default pokeSlice.reducer;